module.exports = __webpack_public_path__ + "static/media/shopping-cart.7d10a477.svg";